import { BrowserRouter, useLocation } from "react-router-dom";
import routes from "./constants/routes";

import Header from "./components/Header/Header";
import AppRoutes from "./Routes";

const AppContent = () => {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();
  const loginPath = routes.login.root.toLowerCase();
  const isLoginPage = currentPath === loginPath;

  return (
    <div>
      {!isLoginPage && <Header />}
      <AppRoutes />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
